import React from 'react';
import Table from 'react-bootstrap/Table';
import { highlightDiffFormatter, niceDateFormatter, niceDateTimeFormatter, userNameFormatter } from '../../lib/helper/formatting';
import { connect } from 'react-redux';
import clsx from 'clsx';
import * as ROUTES from '../../lib/routing/frontend';
import { Link } from 'react-router-dom';
import MarkActionedButton from '../../components/invoiceInsuranceDetails/MarkActionedButton';

const AddressList = ({ address }) => {
  return (
    address && (
      <div className="mt-2">
        <h6>Address:</h6>
        <ul className="list-unstyled mb-0">
          {address.line1 && <li>{address.line1}</li>}
          {address.line2 && <li>{address.line2}</li>}
          {address.line3 && <li>{address.line3}</li>}
          {address.city && <li>{address.city}</li>}
          {address.county && <li>{address.county}</li>}
          {address.postcode && <li>{address.postcode}</li>}
        </ul>
      </div>
    )
  );
};

class InvoiceUpdatedInsuranceDetailsListTable extends React.Component {
  render() {
    const { insuranceDetailUpdates, reload } = this.props;

    if (!insuranceDetailUpdates || insuranceDetailUpdates.length === 0) {
      return null;
    }

    const sortedUpdates = insuranceDetailUpdates.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return (
      <div style={{ overflow: 'none' }}>
        <Table striped hover responsive className="mb-0">
          <thead>
            <tr>
              {/*<th>Item ID</th>*/}
              <th>Inv/Batch No</th>
              <th>Updated At</th>
              <th>By Contact</th>
              <th>Patient Name / DOB</th>
              <th>Insurer</th>
              <th>Membership Number / Auth Code (if supplied)</th>
              <th>Actioned By</th>
              <th className="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedUpdates.map((insuranceUpdate) => {
              const tableInvoice = insuranceUpdate?.invoice;
              const isProblem = (tableInvoice && tableInvoice?.isEscalated) || tableInvoice?.isMissingContactDetails;

              const rowClasses = clsx({
                'table-row--paid': tableInvoice && tableInvoice.isPaid && !tableInvoice.isVoid,
                'table-row--problem': isProblem,
                'table-row--writeoff': tableInvoice && tableInvoice.isWrittenOff,
                'table-row--void': tableInvoice && tableInvoice.isVoid,
                'table-row--urgent': !tableInvoice,
              });

              return (
                <tr key={insuranceUpdate.id} className={rowClasses}>
                  <td>
                    {tableInvoice ? (
                      <Link to={ROUTES.INVOICES.SINGLE.replace(':id', tableInvoice.id)} className="btn btn-sm btn-outline-dark">
                        Invoice: {tableInvoice.invoiceNo}
                      </Link>
                    ) : (
                      <>
                        <Link to={ROUTES.INVOICE_BATCHES.SINGLE.replace(':id', insuranceUpdate.invoiceBatch.id)} className="btn btn-sm btn-outline-dark mr-2">
                          Batch: {insuranceUpdate.invoiceBatch.id}
                        </Link>
                        <Link to={ROUTES.PROBLEM_DATA.SINGLE_EDIT.replace(':id', insuranceUpdate.problemData.id)} className="btn btn-sm btn-outline-dark">
                          Problem: {insuranceUpdate.problemData.id}
                        </Link>
                      </>
                    )}

                    {tableInvoice && tableInvoice.isEscalated && <i className="ml-2 fas fa-exclamation-circle text-danger" title="Escalated" />}
                    {tableInvoice && tableInvoice.disableChasing && <i className="ml-2 fas fa-pause-circle text-danger" title="Notifications Paused" />}

                    {tableInvoice && tableInvoice.isMissingContactDetails && tableInvoice?.missingContactDetailsType && (
                      <>
                        {tableInvoice.missingContactDetailsType.code === '0' && (
                          <i className="ml-2 fas fa-phone text-danger" title={tableInvoice.missingContactDetailsType.name} />
                        )}
                        {tableInvoice.missingContactDetailsType.code === '10' && (
                          <i className="ml-2 fas fa-envelope text-danger" title={tableInvoice.missingContactDetailsType.name} />
                        )}
                        {tableInvoice.missingContactDetailsType.code === '20' && (
                          <>
                            <i className="ml-2 fas fa-phone text-danger" title={tableInvoice.missingContactDetailsType.name} />
                            <i className="ml-2 fas fa-envelope text-danger" title={tableInvoice.missingContactDetailsType.name} />
                          </>
                        )}
                      </>
                    )}
                  </td>
                  <td>{insuranceUpdate.createdAt ? niceDateTimeFormatter(insuranceUpdate.createdAt) : null}</td>
                  {insuranceUpdate.contactRecord ? (
                    <td>
                      {highlightDiffFormatter(insuranceUpdate.requestedBy, insuranceUpdate.contactRecord.name)}
                      {insuranceUpdate.contactEmail ? (
                        <> / {highlightDiffFormatter(insuranceUpdate.contactEmail, insuranceUpdate.contactRecord.email)}</>
                      ) : null}
                      {insuranceUpdate.contactPhone ? (
                        <> / {highlightDiffFormatter(insuranceUpdate.contactPhone, insuranceUpdate.contactRecord.mobileNumber)}</>
                      ) : null}
                    </td>
                  ) : (
                    <td>
                      {insuranceUpdate.requestedBy}
                      {insuranceUpdate.contactEmail ? (
                        <> / {highlightDiffFormatter(insuranceUpdate.contactEmail, insuranceUpdate.problemData.contactEmail)}</>
                      ) : null}
                      {insuranceUpdate.contactPhone ? (
                        <> / {highlightDiffFormatter(insuranceUpdate.contactPhone, insuranceUpdate.problemData.contactPhone)}</>
                      ) : null}
                    </td>
                  )}
                  {tableInvoice ? (
                    <td>
                      {highlightDiffFormatter(insuranceUpdate.patientName, tableInvoice.patientFirstName + ' ' + tableInvoice.patientLastName)} /{' '}
                      {highlightDiffFormatter(niceDateFormatter(insuranceUpdate.dateOfBirth), niceDateFormatter(tableInvoice.dateOfBirth))}
                      <AddressList address={insuranceUpdate?.address} />
                    </td>
                  ) : (
                    <td>
                      {highlightDiffFormatter(
                        insuranceUpdate.patientName,
                        insuranceUpdate.problemData.patientFirstName + ' ' + insuranceUpdate.problemData.patientLastName,
                      )}{' '}
                      / {insuranceUpdate.dateOfBirth ? niceDateFormatter(insuranceUpdate.dateOfBirth) : null}
                      <AddressList address={insuranceUpdate?.address} />
                    </td>
                  )}
                  <td>
                    <strong>
                      {insuranceUpdate.problemData?.insurer
                        ? highlightDiffFormatter(insuranceUpdate.insurer.name, insuranceUpdate.problemData.insurer.name)
                        : insuranceUpdate.insurer.name}
                    </strong>
                  </td>
                  <td>
                    {insuranceUpdate.membershipNumber}
                    {insuranceUpdate.authCode ? ' / ' + insuranceUpdate.authCode : null}
                  </td>
                  <td>
                    {userNameFormatter(insuranceUpdate.actionedBy)} -{' '}
                    {insuranceUpdate.actionedDate ? niceDateTimeFormatter(insuranceUpdate.actionedDate) : null}
                  </td>
                  <td className="text-sm-left text-md-right">
                    {!insuranceUpdate.actionedBy ? <MarkActionedButton invoiceInsuranceDetails={insuranceUpdate} reload={reload} /> : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default connect(null, null)(InvoiceUpdatedInsuranceDetailsListTable);
